import React from "react";
import { Link } from "react-router-dom";
import { BsGithub, BsLinkedin } from "react-icons/bs";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark nav-blur">
      <div className="container-fluid px-4">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <img src="./icon (1).ico" alt="logo" />
          <span className="fw-bold">Aritra</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
          <div className="navbar-nav align-items-lg-center gap-lg-3">
            <Link className="nav-link" to="/projects">
              Projects
            </Link>
            <Link className="nav-link" to="/blogs">
              Writing
            </Link>
            <Link className="nav-link" to="/resume">
              Resume
            </Link>
            <Link className="nav-link" to="/aboutme">
              About
            </Link>
            <Link className="nav-link" to="/contact">
              Contact
            </Link>
            <a
              className="nav-link d-none d-lg-inline-flex align-items-center gap-2"
              href="https://www.linkedin.com/in/aritra-bhattacharjee/"
              target="_blank"
              rel="noreferrer"
            >
              <BsLinkedin />
            </a>
            <a
              className="nav-link d-none d-lg-inline-flex align-items-center gap-2"
              href="https://github.com/AritraBhattacharjee"
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
